import * as React from "react"
import { Container, Section, Text, Box, Button } from "./ui"
import { checkSectionToHex } from "../helper-functions"
import { GatsbyImage } from "gatsby-plugin-image"

export default function Contact(props) {
  return (
    <>
      <div style={{ display: "grid" }}>
        <GatsbyImage
          alt={props.image.alt}
          image={props.image.localFile.childImageSharp.gatsbyImageData}
          style={{
            gridArea: "1/1",
            maxHeight: "550px",
            width: "100%",
            borderTop: `200px solid ${checkSectionToHex(props.maxIndex)}`,
          }}
          layout="fullWidth"
        />
        <div
          style={{
            gridArea: "1/1",
            position: "relative",
            placeItems: "center",
            display: "grid",
            top: "0",
          }}
        >
          <Section>
            <Container width="normal">
              <Box paddingMain paddingY={5} background="white" width="half">
                <Box>
                  <Text variant="subhead">{props.title}</Text>
                  <Text>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: props.body,
                      }}
                    />
                  </Text>
                  <Button to={props.link.href}>{props.link.text}</Button>
                </Box>
              </Box>
            </Container>
          </Section>
        </div>
      </div>
    </>
  )
}
